export default {
    fr: {
        LP: {
            nav: [{
                    name: "TOP",
                    id: "nav-top"
                },
                {
                    name: "Message de l’artiste",
                    id: "nav-message"
                },
                {
                    name: "L’expérience",
                    id: "nav-expenrise"
                },
                {
                    name: "RYOTARO MURAMATSU",
                    id: "nav-artist"
                },
                {
                    name: "Emplacements",
                    id: "nav-place"
                },
                {
                    name: "Notre Dandelion (Dent-de-lion)",
                    id: "nav-result"
                },
                // {
                //     name: "植樹支援のお願い",
                //     id: "nav-contribution"
                // },
                {
                    name: "Supportez ce projet",
                    id: "nav-supporters"
                },
                {
                    name: "Contactez-nous",
                    id: "nav-supporters"
                },
            ],
            top_desc_mb: "<i>DANDELION</i> est une oeuvre d’art connecté au monde.\n\nSoufflez sur <i>DANDELION</i> ,et ses aigrettes dériveront vers un autre <i>DANDELION</i> dans le monde pour y produire une nouvelle fleur.\n\nLes fleurs que nous envoyons se rassemblent à chaque endroit et finissent par devenir un jardin.\n\n\"Qu'il y ait la paix.\" \"Que ce monde devienne un endroit meilleur.\"\nEnvoyez votre prière sur une les aigrettes de pissenlit,\net laissez votre fleur fleurir dans le monde.",
            top_desc_pc: "<i>DANDELION</i> est une oeuvre d’art connecté au monde.\n\nSoufflez sur <i>DANDELION</i> ,et ses aigrettes dériveront vers un autre <i>DANDELION</i> dans le monde pour y produire une nouvelle fleur.\n\nLes fleurs que nous envoyons se rassemblent à chaque endroit et finissent par devenir un jardin.\n\n\"Qu'il y ait la paix.\" \"Que ce monde devienne un endroit meilleur.\"\nEnvoyez votre prière sur une les aigrettes de pissenlit,\net laissez votre fleur fleurir dans le monde.",
            msg: {
                msg_title: "Message de l’Artiste",
                msg_desc_mb: "Notre monde a changé à bien des égards depuis le début de 2020.Je m'interroge sur les changements qui pourraient survenir dans la façon dont nous nous connectons au monde et les uns aux autres.\n\nGrace aux technologies modernes, tout le monde est capable de communiquer et de partager ses sentiments avec le monde. Bien que nous nous retrouvions constamment à affirmer verbalement nos propres points de vue, je pense qu'il existe également un moyen pour les gens de se connecter par le biais de voeux en faveur de la paix et le bien-être des uns et des autres.\n\n<i>DANDELION</i> est une oeuvre d’art qui relie les gens du monde entier grace a une action très simple. J'aime cette pièce, car elle incarne la simplicité de faire un vœu sur un pissenlit ou dent-de-lion : un souvenir d'enfance auquel nous pouvons tous nous identifier, ainsi que son de pouvoir produire immédiatement des fleurs dans plusieurs endroits du monde.\n\nLes fleurs n'ont pas besoin de mots. elles sont totalement impartiales. Leurs graines volent vers de nouveaux endroits et y fleurissent. J'espère que nous pourrons dépasser les contraintes de race, de nationalité ou de croyance, pour nous connecter les uns aux autres à travers l'art et planter des fleurs de paix à travers le monde.",
                msg_desc_pc: "Notre monde a changé à bien des égards depuis le début de 2020.Je m'interroge sur les changements qui pourraient survenir dans la façon dont nous nous connectons au monde et les uns aux autres.\n\nGrace aux technologies modernes, tout le monde est capable de communiquer et de partager ses sentiments avec le monde. Bien que nous nous retrouvions constamment à affirmer verbalement nos propres points de vue, je pense qu'il existe également un moyen pour les gens de se connecter par le biais de voeux en faveur de la paix et le bien-être des uns et des autres.\n\n<i>DANDELION</i> est une oeuvre d’art qui relie les gens du monde entier grace a une action très simple. J'aime cette pièce, car elle incarne la simplicité de faire un vœu sur un pissenlit ou dent-de-lion : un souvenir d'enfance auquel nous pouvons tous nous identifier, ainsi que son de pouvoir produire immédiatement des fleurs dans plusieurs endroits du monde.\n\nLes fleurs n'ont pas besoin de mots. elles sont totalement impartiales. Leurs graines volent vers de nouveaux endroits et y fleurissent. J'espère que nous pourrons dépasser les contraintes de race, de nationalité ou de croyance, pour nous connecter les uns aux autres à travers l'art et planter des fleurs de paix à travers le monde.",

                msg_foot: "Ryotaro Muramatsu / NAKED"
            },
            art: {
                title1: "A propos de l’artiste",
                title2: "Ryotaro Muramatsu / NAKED",
                title3: "ARTIST",
                desc1: "Depuis la fondation de la société de création NAKED Inc. en 1997, l'artiste basé à Tokyo a dirigé des projets dans divers domaines tels que le cinéma, la télévision, les vidéoclips, les publicités et la présentation spatiale. ",
                desc2: "Depuis la fondation de la société de création NAKED Inc. en 1997, l'artiste basé à Tokyo a dirigé des projets dans divers domaines tels que le cinéma, la télévision, les vidéoclips, les publicités et la présentation spatiale. Les films qu'il a réalisés ont reçu 48 nominations et récompenses dans des festivals de cinéma à travers le monde. Ces dernières années, il a produit des événements artistiques immersifs, notamment FLOWERS BY NAKED et TOKYO ART CITY BY NAKED, ainsi que des événements, des installations et des performances en direct en collaboration avec des leaders de la culture traditionnelle japonaise. Tout en enseignant en tant que professeur invité à l'Université des arts d'Osaka, il dirige également des événements de revitalisation locaux et des programmes culturels dans des communautés à travers le Japon, à commencer par Achi Village à Nagano, où il est directeur de la marque.En 2018, il a commencé à créer des œuvres en tant qu'artiste solo et a depuis présenté son art a travers le Japon et à l'étranger. En 2019, il a participé à l'exposition DIVERSITÉ POUR LA PAIX ! détenu par le Karuizawa New Art Museum à Venise, en Italie, et à la SUZHOU DESIGN WEEK à Suzhou, en Chine. À Hong Kong, il a présenté sa première exposition solo à l'étranger 002 à la Hong Kong Whitestone Gallery de HQUEENS et a créé une expérience immersive lors du dîner client Christie's Autumn Auctions 2019. En 2020, il a lancé une initiative artistique internationale DANDELION PROJECT qui vise à unir les prières des gens pour la paix dans le monde en « plantant » des sculptures de pissenlit interconnectées dans des endroits du monde entier.",
            },
            experrience: {
                text_title1: 'L’EXPÉRIENCE',
                text_title2_mb: "Envoyer votre grainette de Dandelion dans le monde",
                text_title2_pc: "Envoyer votre grainette de Dandelion dans le monde",
                text_btn: 'Découvrez le\nDANDELION',
                text_link: 'Supportez\nce projet',
                text_desc: "Supportez ce projet en “plantant” des Dandelion dans le monde.",
            },
            result: {
                text_title1_mb: "NOTRE DANDELION",
                text_title1_pc: "NOTRE DANDELION",
                text_title2: "Les Amis du\nProjet Dandelion",
                text_desc: "Chaque grainette de dandelion feront parti a jamais d’un Dandelion Virtuel qui continuera de grandir au cour des années.",
                names: [{
                    firstName: "佐野光咲",
                    lastName: ""
                }, {
                    firstName: "佐野正騎",
                    lastName: ""
                }, {
                    firstName: "NOBU. MARUYAMA",
                    lastName: ""
                }, {
                    firstName: "JUN TERAYAMA",
                    lastName: ""
                }, {
                    firstName: "Ryuta Shimba",
                    lastName: ""
                }, {
                    firstName: "Shinsaku Nakagawa",
                    lastName: ""
                }, {
                    firstName: "Reiji Higashimaki",
                    lastName: ""
                }, {
                    firstName: "Erina",
                    lastName: ""
                }, {
                    firstName: "衞藤登喜子",
                    lastName: ""
                }, {
                    firstName: "深田しのぶ",
                    lastName: ""
                }, {
                    firstName: "小林優人",
                    lastName: ""
                }, {
                    firstName: "松田英樹",
                    lastName: ""
                }, {
                    firstName: "衞藤正和",
                    lastName: ""
                }, {
                    firstName: "衞藤弥保",
                    lastName: ""
                }]
            },
            placeText: {
                title: "Emplacements",
                desc_mb: "",
                desc_pc: ""
            },
            ctr: {
                title1: "Supportez ce projet",
                title2: "",
                desc1_mb: "Aidez nous a Planter des <i>DANDELION</i>  a travers le monde.\nFaites parti d’un projet pour créer un symbole de la Paix dans le monde.",
                desc1_pc: "Aidez nous a Planter des <i>DANDELION</i>  a travers le monde.\nFaites parti d’un projet pour créer un symbole de la Paix dans le monde.",
                desc2: "Veuillez sélectionner le montant de l'assistance parmi les suivants et cliquez sur le bouton \"Je veux supporter\".",
                btn1: "Je veux supporter",
                btn2: "",
                input_tips: "Veuillez entrer le montant librement.",
                price_type: "USD$",
                safari_tips1: "※Si vous utilisez Safari, veuillez",
                safari_tips2: " cliquer ",
                safari_tips3: "ici.",
                safari_setting_tips: "Si vous utilisez Safari, veuillez vérifier les paramètres suivants. \nParamètres> Safari> Bloquer les  pop-up> OFF \nVeuillez définir.",
                min_money_tips: "※Vous pouvez entrer à partir de USD 0.5",
                law_tips: 'Specified Commercial Transaction Act',
                pay_urls: [{
                        name: "JP¥100",
                        url: "https://buy.stripe.com/4gw16J9ea1vN2IMdQS"
                    },
                    {
                        name: "JP¥500",
                        url: "https://buy.stripe.com/eVa02Fbmi5M31EI9AD"
                    }, {
                        name: "JP¥1,000",
                        url: "https://buy.stripe.com/00g02Fcqm1vNfvy7sw"
                    },
                    {
                        name: "JP¥10,000",
                        url: "https://buy.stripe.com/eVabLnfCy6Q7fvy7sx"
                    }
                ]

            },
            supportTitle: "SUPPORTERS",
            contactTitle: "CONTACT US",
            // OGP用情報
            ogp: {
                title: 'DANDELION PROJECT',
                description: 'Connecting Prayers for Peace with Breath/Bless Project',
                type: 'website',
                url: 'www.breathbless.com',
                site_name: 'DANDELION PROJECT Official Site',
                image: '/Images/Ogp/OGP_breath.jpg',
                twitter_card: 'summary_large_image'
            },

            // タイトル
            title: 'Uniting Prayers for Peace',
            title_sp: 'Uniting' +
                '\r\n' +
                'Prayers' +
                '\r\n' +
                'for' +
                '\r\n' +
                'Peace',

            // サブタイトル
            subtitle: '',

            // ページの詳細
            description: 'This is an artwork that keeps growing as it connects locations and people around the world.' +
                '\r\n' +
                '\r\n' +
                'When you blow your breath on a <i>Dandelion</i>,' +
                '\r\n' +
                'the fluff will float to a faraway city and produce a new, beautiful flower there.' +
                '\r\n' +
                '\r\n' +
                ' A “<i>Breath</i>” sends prayers from one place to another, ' +
                '\r\n' +
                'filling the world with “<i>Blessings</i>,” or prayers for peace.' +
                '\r\n' +
                '\r\n' +
                'Real locations and the virtual world synchronize,' +
                '\r\n' +
                'as the network itself, which connects the many prayers, becomes the artwork.',
            description_sp: 'This is an artwork that keeps growing as it connects' +
                '\r\n' +
                'locations and people around the world.' +
                '\r\n' +
                '\r\n' +
                'When you blow your breath on a <i>Dandelion</i>,' +
                '\r\n' +
                'the fluff will float to a faraway city and produce a new,' +
                '\r\n' +
                'beautiful flower there.' +
                '\r\n' +
                '\r\n' +
                ' A “<i>Breath</i>” sends prayers from one place to another, ' +
                '\r\n' +
                'filling the world with “<i>Blessings</i>,” or prayers for peace.' +
                '\r\n' +
                '\r\n' +
                'Real locations and the virtual world synchronize,' +
                '\r\n' +
                'as the network itself, which connects the many prayers,' +
                '\r\n' +
                'becomes the artwork.',


            subtitle2: 'Let your own flower of prayers bloom in the world',

            textcontents_qr: 'If you are nearby a <i>Dandelion</i>',
            textcontents_qr_button: 'INTERACTIVE CODE',

            textcontents_ol: 'If you are joining in online',
            textcontents_ol_button: 'FIND YOUR FLOWER',

            // Send a Prayerボタンから出るモーダルに表示される画像
            // send_modal_image: './Images/LP_dande_contents_0822.jpg',
            // send_modal_image_sp: './Images/LP_dande_SP-contents_0824.jpg',
            // send_modal_image_tb: './Images/LP_dande_ipad_0825.jpg',

            send_modal_image: './Images/maker_en.jpg',
            // send_modal_image_sp: './Images/mask_image.jpg',
            // send_modal_image_tb: './Images/mask_image.jpg',

            // メッセージ
            //
            // thumbnail => サムネイル画像
            // title => タイトル
            // description => 詳細説明
            message: {
                thumbnail: './Images/RM.jpg',
                title: 'ARTIST',
                name: 'Ryotaro Muramatsu /NAKED, INC. ',
                description: 'Since founding the creative company NAKED, INC. in 1997, the Tokyo based artist has led projects in various fields such as film, television, music videos, advertisements, and spatial presentation. The films he directed have received 48 nominations and awards at film festivals around the world. In recent years he has produced immersive art events including FLOWERS BY NAKED and TOKYO ART CITY BY NAKED, along with events, installations, and live performances in collaboration with leaders of traditional Japanese culture. While teaching as visiting professor at Osaka University of Arts, he also leads local revitalization events and cultural programs in communities around Japan, starting with Achi Village, Nagano where he is branding director. In 2018, he started creating works as a solo artist and since has presented his art both in Japan and overseas. In 2019, he participated in the exhibition "DIVERSITY FOR PEACE!" held by Karuizawa New Art Museum in Venice, Italy, and at the SUZHOU DESIGN WEEK in Suzhou, China. In Hong Kong, he presented his first overseas solo exhibition 002 at HQUEENS\'s Hong Kong Whitestone Gallery, and created an immersive experience at Christie\'s Autumn Auctions 2019 client dinner.',
                message: 'Our world has changed in so many ways since the beginning of 2020, and difficult times continue. People all over the globe, from every background, wish fervently for a better world. It is my hope that our shared adversity will not divide us but will, instead, bring us closer together.  ' +
                    '\r\n' +
                    '\r\n' +
                    '<i>Dandelion</i> is an interactive artwork that evokes the feeling one gets from making a wish on a dandelion. When the viewer blows a breath on the <i>Dandelion</i> installation, the fluff floats away, eventually landing on the ground and producing a new flower. I am fond of this digitally augmented piece, as it brings back the pure, simple childhood feeling we all remember and can relate to beyond the constraints of race, nationality, or belief.' +
                    '\r\n' +
                    '\r\n' +
                    'This artwork is alive.' +
                    '\r\n' +
                    'As more <i>Dandelion</i> installations are set up around the world and more people participate, their many prayers will connect within this large and ever-expanding artwork. In past years, I have created works that integrate virtual and real, digital and analog; what I wish to offer the world today is an artwork that transcends barriers to unite people’s hearts.' +
                    '\r\n' +
                    '\r\n' +
                    'Flowers need no words. They are completely impartial.' +
                    '\r\n' +
                    'Their seeds fly to new places and bloom there.' +
                    '\r\n' +
                    'Through this art, I hope to spread this spirit, to plant flowers of peace throughout the world.' +
                    '\r\n' +
                    '\r\n' +
                    '<p style="font-size: 1.0rem;">Ryotaro Muramatsu / NAKED</p>',
                message_sp: '<font size="4">"</font>Our world has changed in so many ways since the beginning of 2020, and difficult times continue. People all over the globe, from every background, wish fervently for a better world. It is my hope that our shared adversity will not divide us but will, instead, bring us closer together.  ' +
                    '\r\n' +
                    '\r\n' +
                    '<i>Dandelion</i> is an interactive artwork that evokes the feeling one gets from making a wish on a dandelion. When the viewer blows a breath on the <i>Dandelion</i> installation, the fluff floats away, eventually landing on the ground and producing a new flower. I am fond of this digitally augmented piece, as it brings back the pure, simple childhood feeling we all remember and can relate to beyond the constraints of race, nationality, or belief.' +
                    '\r\n' +
                    '\r\n' +
                    'This artwork is alive.' +
                    '\r\n' +
                    'As more <i>Dandelion</i> installations are set up around the world and more people participate, their many prayers will connect within this large and ever-expanding artwork. In past years, I have created works that integrate virtual and real, digital and analog; what I wish to offer the world today is an artwork that transcends barriers to unite people’s hearts.' +
                    '\r\n' +
                    '\r\n' +
                    'Flowers need no words. They are completely impartial.' +
                    '\r\n' +
                    'Their seeds fly to new places and bloom there.' +
                    '\r\n' +
                    'Through this art, I hope to spread this spirit, to plant flowers of peace throughout the world.<font size="4">"</font>'
            },

            // 寄付のお願い
            contribution: {
                title_pc: 'Join us to plant <i>Dandelions</i> around the world',
                title_sp: 'Join us to plant <i>Dandelions</i>' +
                    '\r\n' +
                    'around the world',
                message: '<i>DANDELION PROJECT</i> asks for your support to “plant”' +
                    '\r\n' +
                    'interactive <i>Dandelion</i> installations around the world.' +
                    '\r\n' +
                    'Join us to spread this symbol of prayers for peace,' +
                    '\r\n' +
                    'and fill the world with flowers.' +
                    '\r\n' +
                    '\r\n',
                message_sp: '<i>DANDELION PROJECT</i> asks for your support to “plant”' +
                    '\r\n' +
                    'interactive <i>Dandelion</i> installations around the world.' +
                    '\r\n' +
                    'Join us to spread this symbol of prayers for peace,' +
                    '\r\n' +
                    'and fill the world with flowers.' +
                    '\r\n' +
                    '\r\n',
                button: 'Fund this artwork',
                cloudfunding_abount: '',
                cloudfunding_description: 'There are many other ways to support this project.',
                cloudfunding_description_sp: 'There are many other ways to support this project.',
                cloudfunding_button: 'Learn more',
                cloudfunding_image: './Images/cf_logo_padded.png',
                cloudfunding_url: 'https://camp-fire.jp/projects/view/314807'
            },
            supporters: [{
                    logo: './Images/Supporters/GB Logo SG_4C_Grey.png',
                    url: ''
                },
                {
                    logo: './Images/Supporters/sas.png',
                    url: ''
                },
                {
                    logo: './Images/Supporters/pds.png',
                    url: ''
                },
                {
                    logo: './Images/Supporters/tt.png',
                    url: ''
                },
                {
                    logo: './Images/Supporters/kddi.png',
                    url: ''
                },
                {
                    logo: './Images/Supporters/livecamera_venice.png',
                    url: ''
                },
                {
                    logo: './Images/Supporters/livecamera_tokyo.png',
                    url: ''
                },
                {
                    logo: './Images/Supporters/livecamera_capetown.png',
                    url: ''
                },
                {
                    logo: './Images/Supporters/gl.png',
                    url: ''
                }
            ],

            place: [{
                    name_mb1: 'JAPON・HIROSHIMA',
                    name_mb2: 'ORIZURU TOWER',
                    image_mb: './Images/Place/mb/s00145.png',
                    name: 'JAPON・HIROSHIMA / ORIZURU TOWER',
                    time: '2023.5.19 ー',
                    image: './Images/Place/s00145.png',
                    tips: 'Billet Requis',
                    url_msg: '',
                    url: ''
                }, {
                    name_mb1: 'Séoul, Corée du Sud',
                    name_mb2: '',
                    image_mb: './Images/Place/mb/s00178.png',
                    name: 'Séoul, Corée du Sud',
                    time: '2026.8.1 ー 2026.10.31',
                    image: './Images/Place/s00178.png',
                    tips: 'Billet Requis',
                    url_msg: '',
                    url: ''
                }, {
                    name_mb1: 'Japon・Osaka',
                    name_mb2: 'VS. (au sein de GRAND GREEN OSAKA)',
                    image_mb: './Images/Place/mb/s00177.png',
                    name: 'Japon・Osaka / VS. (au sein de GRAND GREEN OSAKA)',
                    time: '2026.4.17 ー 2026.6.15',
                    image: './Images/Place/s00177.png',
                    tips: 'Billet Requis',
                    url_msg: 'VOIR PLUS',
                    url: 'https://meets.naked.works/gaudi/'
                }, {
                    name_mb1: 'Taïwan・Taipei',
                    name_mb2: 'Parc culturel et créatif de Songyan',
                    image_mb: './Images/Place/mb/s00176.png',
                    name: 'Taïwan・Taipei / Parc culturel et créatif de Songyan',
                    time: '2026.1.31 ー 2026.6.30',
                    image: './Images/Place/s00176.png',
                    tips: 'Exposition Gratuite',
                    url_msg: '',
                    url: ''
                }, {
                    name_mb1: 'JAPON・TOKYO',
                    name_mb2: 'Entrepôt Terada',
                    image_mb: './Images/Place/mb/s00175.png',
                    name: 'JAPON・TOKYO / Entrepôt Terada',
                    time: '2026.1.10 ー 2026.3.15',
                    image: './Images/Place/s00175.png',
                    tips: 'Billet Requis',
                    url_msg: 'VOIR PLUS',
                    url: 'https://meets.naked.works/gaudi/'
                }, {
                    name_mb1: 'APON・HYOGO',
                    name_mb2: 'Château de Himeji – Place Sannomaru',
                    image_mb: './Images/Place/mb/s00174.png',
                    name: 'APON・HYOGO / Château de Himeji – Place Sannomaru',
                    time: '2025.11.22 ー 2025.12.11',
                    image: './Images/Place/s00174.png',
                    tips: 'Billet Requis',
                    url_msg: 'VOIR PLUS',
                    url: 'http://himeji-castle-dandelion.art/'
                }, {
                    name_mb1: 'JAPON・KYOTO',
                    name_mb2: 'Yasaka Shrine',
                    image_mb: './Images/Place/mb/s00173.png',
                    name: 'JAPON・KYOTO / Yasaka Shrine',
                    time: '2025.8.8 ー 2025.8.17',
                    image: './Images/Place/s00173.png',
                    tips: 'Exposition Gratuite',
                    url_msg: '',
                    url: ''
                }, {
                    name_mb1: 'JAPON・KYOTO',
                    name_mb2: 'Sanctuaire Fushimi Inari-taisha',
                    image_mb: './Images/Place/mb/s00172.png',
                    name: 'JAPON・KYOTO / Sanctuaire Fushimi Inari-taisha',
                    time: '2025.7.19 ー 2025.8.17',
                    image: './Images/Place/s00172.png',
                    tips: 'Exposition Gratuite',
                    url_msg: '',
                    url: ''
                }, {
                    name_mb1: 'JAPON・HYOGO',
                    name_mb2: 'Jardin botanique alpin de Rokko',
                    image_mb: './Images/Place/mb/s00171.png',
                    name: 'JAPON・HYOGO / Jardin botanique alpin de Rokko',
                    time: '2025.9.20 ー 2025.12.30',
                    image: './Images/Place/s00171.png',
                    tips: 'Billet Requis',
                    url_msg: 'VOIR PLUS',
                    url: 'https://rokkomeetsart.jp/'
                }, {
                    name_mb1: 'JAPON・KYOTO',
                    name_mb2: 'Le Château d\'NIJO-JO',
                    image_mb: './Images/Place/mb/s00170.png',
                    name: 'JAPON・KYOTO / Le Château d\'NIJO-JO',
                    time: '2025.3.14 ー 2025.4.13',
                    image: './Images/Place/s00170.png',
                    tips: 'Billet Requis',
                    url_msg: 'VOIR PLUS',
                    url: 'https://event.naked.works/nijojo/spring/ja/'
                }, {
                    name_mb1: 'CHINE・Pekin',
                    name_mb2: 'Musée Meet You',
                    image_mb: './Images/Place/mb/s00168.png',
                    name: 'CHINE・Pekin / Musée Meet You',
                    time: '2024.11.15 ー 2025.2.16',
                    image: './Images/Place/s00168.png',
                    tips: 'Billet Requis',
                    url_msg: '',
                    url: ''
                }, {
                    name_mb1: 'JAPON・SHIGA',
                    name_mb2: 'Sanctuaire Hiyoshi Taisha（Sanctuaire Shirayamahime）',
                    image_mb: './Images/Place/mb/s00167.png',
                    name: 'JAPON・SHIGA / Sanctuaire Hiyoshi Taisha（Sanctuaire Shirayamahime）',
                    time: '2024.11.1 ー 2024.12.8',
                    image: './Images/Place/s00167.png',
                    tips: 'Exposition Gratuite',
                    url_msg: '',
                    url: ''
                }, {
                    name_mb1: 'JAPON・ISHIKAWA',
                    name_mb2: 'Temple Natadera',
                    image_mb: './Images/Place/mb/s00166.png',
                    name: 'JAPON・ISHIKAWA / Temple Natadera',
                    time: '2024.10.25 ー 2024.11.24',
                    image: './Images/Place/s00166.png',
                    tips: 'Billet Requis',
                    url_msg: 'VOIR PLUS',
                    url: 'https://yoru-sanpo.naked.works/natadera/'
                }, {
                    name_mb1: 'JAPON・SHIGA',
                    name_mb2: 'Temple Enryakuji du Mont Hiei Salle Shaka-do',
                    image_mb: './Images/Place/mb/s00164.png',
                    name: 'JAPON・SHIGA / Temple Enryakuji du Mont Hiei Salle Shaka-do',
                    time: '2024.9.13 ー 2024.12.8',
                    image: './Images/Place/s00164.jpg',
                    tips: 'Billet Requis',
                    url_msg: '',
                    url: ''
                }, {
                    name_mb1: 'JAPON・SHIGA',
                    name_mb2: 'Le Château d\'HIKONE',
                    image_mb: './Images/Place/mb/s00162.png',
                    name: 'JAPON・SHIGA / Le Château d\'HIKONE',
                    time: '2024.3.31 ー 2024.4.9',
                    image: './Images/Place/s00162.jpg',
                    tips: 'Billet Requis',
                    url_msg: 'VOIR PLUS',
                    url: 'https://www.knt.co.jp/ec/2023/hikone_night_tour/'
                },
                // {
                //     name_mb1: 'JAPAN・OSAKA',
                //     name_mb2: 'Pont d\'observation de l\'Abeno Harukas \"Harukas 300\"',
                //     image_mb: './Images/Place/mb/s00157.png',
                //     name: '	JAPAN・OSAKA / Pont d\'observation de l\'Abeno Harukas \"Harukas 300\"',
                //     time: '2023.11.28 ー 2024.3.31',
                //     image: './Images/Place/s00157.jpg',
                //     tips: 'Billet Requis',
                //     url_msg: 'VOIR PLUS',
                //     url: 'https://ultraxperience.jp/0x0mugen-project/page_clf.html'
                // }, 
                {
                    name_mb1: 'JAPAN・OSAKA',
                    name_mb2: 'Parc commémoratif de l\'Expo 70',
                    image_mb: './Images/Place/mb/s00156.png',
                    name: 'JAPAN・OSAKA / Parc commémoratif de l\'Expo 70',
                    time: '2023.12.1 ー 2023.12.25',
                    image: './Images/Place/s00156.jpg',
                    tips: 'Billet Requis',
                    url_msg: '',
                    url: ''
                }, {
                    name_mb1: 'JAPON・SHIGA',
                    name_mb2: 'Le Château d\'HIKONE',
                    image_mb: './Images/Place/mb/s00155.png',
                    name: 'JAPON・SHIGA /  Le Château d\'HIKONE',
                    time: '2023.11.11 ー 2023.12.9',
                    image: './Images/Place/s00155.jpg',
                    tips: 'Billet Requis',
                    url_msg: 'VOIR PLUS',
                    url: 'https://www.knt.co.jp/ec/2023/hikone_night_tour/'
                }, {
                    name_mb1: 'JAPON・KYOTO',
                    name_mb2: 'Le Château d\'NIJO-JO',
                    image_mb: './Images/Place/mb/s00144.png',
                    name: 'JAPON・KYOTO /  Le Château d\'NIJO-JO',
                    time: '2023.3.16 ー 2023.4.16',
                    image: './Images/Place/s00144.jpg',
                    tips: 'Billet Requis',
                    url_msg: 'VOIR PLUS',
                    url: 'https://garden.naked.works/kyoto/'
                }, {
                    name_mb1: 'JAPON・OSAKA',
                    name_mb2: 'W OSAKA',
                    image_mb: './Images/Place/mb/s00141.png',
                    name: 'JAPON・OSAKA / W OSAKA',
                    time: '2022.12.15 ー 2022.12.25',
                    image: './Images/Place/s00141.jpg',
                    tips: 'Exposition Gratuite',
                    url_msg: 'VOIR PLUS',
                    url: 'https://garden.naked.works/kyoto/'
                }, {
                    name_mb1: 'JAPON・KYOTO',
                    name_mb2: 'Le musée national de KYOTO',
                    image_mb: './Images/Place/mb/s00136.png',
                    name: 'JAPON・KYOTO / Le musée national de KYOTO',
                    time: '2022.12.10 ー 2022.12.25',
                    image: './Images/Place/s00136.jpg',
                    tips: 'Billet Requis',
                    url_msg: 'VOIR PLUS',
                    url: 'https://garden.naked.works/kyoto/'
                }, {
                    name_mb1: 'JAPON・KYOTO',
                    name_mb2: 'Le Temple NINNA-JI',
                    image_mb: './Images/Place/mb/s00135.png',
                    name: 'JAPON・KYOTO / Le Temple NINNA-JI',
                    time: '2022.12.10 ー 2022.12.18',
                    image: './Images/Place/s00135.jpg',
                    tips: 'Billet Requis',
                    url_msg: 'VOIR PLUS',
                    url: 'https://garden.naked.works/kyoto/'
                }, {
                    name_mb1: 'JAPON・KYOTO',
                    name_mb2: 'ACE HÔTEL KYOTO',
                    image_mb: './Images/Place/mb/s00134.png',
                    name: 'JAPON・KYOTO / ACE HÔTEL KYOTO',
                    time: '2022.12.8 ー 2022.12.25',
                    image: './Images/Place/s00134.jpg',
                    tips: 'Exposition Gratuite',
                    url_msg: 'VOIR PLUS',
                    url: 'https://garden.naked.works/kyoto/'
                }, {
                    name_mb1: 'JAPON・KYOTO',
                    name_mb2: 'La porte KARAMON de NISHI HONGANJI Temple',
                    image_mb: './Images/Place/mb/s00133.png',
                    name: 'JAPON・KYOTO / La porte KARAMON de NISHI HONGANJI Temple',
                    time: '2022.11.24 ー 2022.11.27',
                    image: './Images/Place/s00133.jpg',
                    tips: 'Billet Requis',
                    url_msg: 'VOIR PLUS',
                    url: 'https://garden.naked.works/kyoto/'
                }, {
                    name_mb1: 'JAPON・KYOTO',
                    name_mb2: 'Le Sanctuaire HEIAN JINGU',
                    image_mb: './Images/Place/mb/s00132.png',
                    name: 'JAPON・KYOTO / Le Sanctuaire HEIAN JINGU',
                    time: '2022.11.18 ー 2022.12.25',
                    image: './Images/Place/s00132.jpg',
                    tips: 'Billet Requis',
                    url_msg: 'VOIR PLUS',
                    url: 'https://garden.naked.works/kyoto/'
                }, {
                    name_mb1: 'JAPON・KYOTO',
                    name_mb2: 'Sanctuaire KITANO TENMANGU',
                    image_mb: './Images/Place/mb/s00131.png',
                    name: 'JAPON・KYOTO / Sanctuaire KITANO TENMANGU',
                    time: '2022.11.12 ー 2022.11.27',
                    image: './Images/Place/s00131.jpg',
                    tips: 'Billet Requis',
                    url_msg: 'VOIR PLUS',
                    url: 'https://garden.naked.works/kyoto/'
                }, {
                    name_mb1: 'JAPON・UJI',
                    name_mb2: 'Ville d\'UJI',
                    image_mb: './Images/Place/mb/s00130.png',
                    name: 'JAPON・UJI / Ville d\'UJI',
                    time: '2022.11.11 ー 2022.12.4',
                    image: './Images/Place/s00130.jpg',
                    tips: 'Billet Requis',
                    url_msg: 'VOIR PLUS',
                    url: 'https://garden.naked.works/kyoto/'
                }, {
                    name_mb1: 'JAPON・SHIGA',
                    name_mb2: 'Le Château d\'HIKONE',
                    image_mb: './Images/Place/mb/2022_10_dandelion_castle_fin_web.png',
                    name: 'JAPON・SHIGA /  Le Château d\'HIKONE',
                    time: '2022.11.3 ー 2022.12.4',
                    image: './Images/Place/2022_10_dandelion_castle_fin_web.jpg',
                    tips: 'Billet Requis',
                    url_msg: '',
                    url: ''
                }, {
                    name_mb1: 'JAPON・SHIGA',
                    name_mb2: 'Le Temple SHIGA-IN MONSEKI',
                    image_mb: './Images/Place/mb/2022_10_dandelion_monseki_fin_web.png',
                    name: 'JAPON・SHIGA / Le Temple SHIGA-IN MONSEKI',
                    time: '2022.11.3 ー 2022.12.4',
                    image: './Images/Place/2022_10_dandelion_monseki_fin_web.jpg',
                    tips: 'Mise à disposition du public(Vendredi,Samedi,Dimanche,Fêtes japonaises)/ Billet Requis',
                    url_msg: 'VOIR PLUS',
                    url: 'https://garden.naked.works/kyoto/'
                }, {
                    name_mb1: 'ARABIE SAOUDITE・RIYADH',
                    name_mb2: 'AL MURABAA',
                    image_mb: './Images/Place/mb/2022_10_dandelion_almurabaa_fin_web.png',
                    name: 'ARABIE SAOUDITE・RIYADH / AL MURABAA',
                    time: '2022.11.1 ー 2022.12.18',
                    image: './Images/Place/2022_10_dandelion_almurabaa_fin_web.jpg',
                    tips: 'Exposition Gratuite',
                    url_msg: '',
                    url: ''
                }, {
                    name_mb1: 'JJAPON・SHIGA',
                    name_mb2: 'Le Château d\'NIJO-JO',
                    image_mb: './Images/Place/mb/2022_10_dandelion_nijojo_fin_web.png',
                    name: 'JJAPON・SHIGA / Le Château d\'NIJO-JO',
                    time: '2022.10.28 ー 2022.12.4',
                    image: './Images/Place/2022_10_dandelion_nijojo_fin_web.jpg',
                    tips: 'Billet Requis',
                    url_msg: 'VOIR PLUS',
                    url: 'https://garden.naked.works/kyoto/'
                }, {
                    name_mb1: 'JAPON・KYOTO',
                    name_mb2: 'Le Temple KAMIGAMO',
                    image_mb: './Images/Place/mb/2022_09_dandelion_kamigamoshrine_fin_web.png',
                    name: 'JAPON・KYOTO / Le Temple KAMIGAMO',
                    time: '2022.10.21 ー 2022.10.23',
                    image: './Images/Place/2022_09_dandelion_kamigamoshrine_fin_web.jpg',
                    tips: 'Exposition Gratuite',
                    url_msg: 'VOIR PLUS',
                    url: 'https://garden.naked.works/kyoto/'
                }, {
                    name_mb1: 'JAPON・OSAKA',
                    name_mb2: 'UMEKITA SOTONIWA SQUARE',
                    image_mb: './Images/Place/mb/2022_09_dandelion_square_fin_web.png',
                    name: 'JAPON・OSAKA / UMEKITA SOTONIWA SQUARE',
                    time: '2022.10.7 ー 2022.10.9',
                    image: './Images/Place/2022_09_dandelion_square_fin_web.jpg',
                    tips: 'Exposition Gratuite',
                    url_msg: 'VOIR PLUS',
                    url: 'https://garden.naked.works/kyoto/'
                }, {
                    name_mb1: 'JAPON・KYOTO',
                    name_mb2: 'Ancienne Villa de la familiale Mitsui à Shimogamo',
                    image_mb: './Images/Place/mb/2022_09_dandelion_oldmitsuifamily_fin_web.png',
                    name: 'JAPON・KYOTO / Ancienne Villa de la familiale Mitsui à Shimogamo',
                    time: '2022.9.23 ー 2022.10.2',
                    image: './Images/Place/2022_09_dandelion_oldmitsuifamily_fin_web.jpg',
                    tips: 'Billet Requis',
                    url_msg: 'VOIR PLUS',
                    url: 'https://garden.naked.works/kyoto/'
                }, {
                    name_mb1: 'JAPON・KYOTO',
                    name_mb2: 'L\'hôtel de ville de KYOTO',
                    image_mb: './Images/Place/mb/2022_09_dandelion_shiyakusyo_fin_web.png',
                    name: 'JAPON・KYOTO / L\'hôtel de ville de KYOTO',
                    time: '2022.9.15 ー 2022.9.16',
                    image: './Images/Place/2022_09_dandelion_shiyakusyo_fin_web.jpg',
                    tips: 'Billet Requis',
                    url_msg: 'VOIR PLUS',
                    url: 'https://garden.naked.works/kyoto/'
                }, {
                    name_mb1: 'JAPON・SHIGA',
                    name_mb2: 'Le Temple ENRYAKUJI',
                    image_mb: './Images/Place/mb/2022_07_dandelion_hieizan_pers_fin_web.png',
                    name: 'JAPON・SHIGA / Le Temple ENRYAKUJI',
                    time: '2022.8.4 ー 2022.8.31',
                    image: './Images/Place/2022_07_dandelion_hieizan_pers_fin_web.jpg',
                    tips: 'Billet Requis',
                    url_msg: '',
                    url: ''
                }, {
                    name_mb1: 'JAPON・KYOTO',
                    name_mb2: 'Le Sanctuaire HEIAN JINGU',
                    image_mb: './Images/Place/mb/2021_09_dande_heianjingu_fin_web.png',
                    name: 'JAPON・KYOTO / Le Sanctuaire HEIAN JINGU',
                    time: '2021.12.15 ー 2022.1.16',
                    image: './Images/Place/2021_09_dande_heianjingu_fin_web.jpg',
                    tips: 'Billet Requis',
                    url_msg: 'VOIR PLUS',
                    url: 'https://garden.naked.works/kyoto/'
                },
                {
                    name_mb1: 'JAPON・KYOTO',
                    name_mb2: 'ARASHIYAMA',
                    image_mb: './Images/Place/mb/2021_09_dande_arashiyama_fin_web.png',
                    name: 'JAPON・KYOTO / ARASHIYAMA',
                    time: '2021.12.10 ー 2021.12.19',
                    image: './Images/Place/2021_09_dande_arashiyama_fin_web.jpg',
                    tips: 'Exposition Gratuite',
                    url_msg: 'VOIR PLUS',
                    url: 'https://garden.naked.works/kyoto/'
                },
                {
                    name_mb1: 'JAPON・KYOTO',
                    name_mb2: 'Le Temple KOUSHOUJI',
                    image_mb: './Images/Place/mb/2021_10_dande_koushouji_fin_web.png',
                    name: 'JAPON・KYOTO / Le Temple KOUSHOUJI',
                    time: '2021.12.3 ー 2021.12.5',
                    image: './Images/Place/2021_10_dande_koushouji_fin_web.jpg',
                    tips: 'Billet Requis',
                    url_msg: 'VOIR PLUS',
                    url: 'https://garden.naked.works/kyoto/'
                }, {
                    name_mb1: 'JAPON・SHIGA',
                    name_mb2: 'Le Château d\'HIKONE',
                    image_mb: './Images/Place/mb/2021_11_dande_hikono_fin_web.png',
                    name: 'JAPON・SHIGA / Le Château d\'HIKONE',
                    time: '2021.11.27 ー 2022.1.30',
                    image: './Images/Place/2021_11_dande_hikono_fin_web.jpg',
                    tips: 'Billet Requis',
                    url_msg: '',
                    url: ''
                },
                {
                    name_mb1: 'JAPON・KO-CHI',
                    name_mb2: 'Le Château d\'KO-CHI',
                    image_mb: './Images/Place/mb/2021_10_dande_kochijo_a4_fin_web.png',
                    name: 'JAPON・KO-CHI/ Le Château d\'KO-CHI',
                    time: '2021.11.19 ー 2022.01.10',
                    image: './Images/Place/2021_10_dande_kochijo_a4_fin_web.jpg',
                    tips: 'Billet Requis',
                    url_msg: 'VOIR PLUS',
                    url: 'https://flowers.naked.works/kochi-castle/'
                },
                {
                    name_mb1: 'JAPON・KUMAMOTO',
                    name_mb2: 'Le Château de KUMAMOTO',
                    image_mb: './Images/Place/mb/2021_dande_kumamotojo_0928_fin_web.png',
                    name: 'JAPON・KUMAMOTO / Le Château de KUMAMOTO',
                    time: '2021.11.19 ー 2021.12.05',
                    image: './Images/Place/2021_dande_kumamotojo_0928_fin_web.jpg',
                    tips: 'Exposition Gratuite',
                    url_msg: '',
                    url: ''
                },
                {
                    name_mb1: 'JAPON・KYOTO',
                    name_mb2: 'Le Temple KIYOMIZU-DERA',
                    image_mb: './Images/Place/mb/2021_10_dande_kiyomizu_1011_fin_web.png',
                    name: 'JAPON・KYOTO / Le Temple KIYOMIZU-DERA',
                    time: '2021.11.17',
                    image: './Images/Place/2021_10_dande_kiyomizu_1011_fin_web.jpg',
                    tips: 'Fermé au Publique',
                    url_msg: 'VOIR PLUS',
                    url: 'https://garden.naked.works/kyoto/'
                },
                {
                    name_mb1: 'JAPON・KYOTO',
                    name_mb2: 'Sanctuaire KITANO TENMANGU',
                    image_mb: './Images/Place/mb/2021_10_dande_kitanotenmangu3_1020_fin_web.png',
                    name: 'JAPON・KYOTO / Sanctuaire KITANO TENMANGU',
                    time: '2021.11.13 ー 2021.11.14',
                    image: './Images/Place/2021_10_dande_kitanotenmangu3_1020_fin_web.jpg',
                    tips: 'Billet Requis',
                    url_msg: 'VOIR PLUS',
                    url: 'https://garden.naked.works/kyoto/'
                },
                {
                    name_mb1: 'FRANCE・PARIS',
                    name_mb2: 'La SAMARITAINE',
                    image_mb: './Images/Place/mb/2021_10_dande_pari_1025-3_web.png',
                    name: 'FRANCE・PARIS / La SAMARITAINE',
                    time: '2021.11.8 ー 2021.11.20',
                    image: './Images/Place/2021_10_dande_pari_1025-3_web.jpg',
                    tips: 'Exposition Gratuite',
                    url_msg: '',
                    url: ''
                },
                {
                    name_mb1: 'JAPON・KYOTO',
                    name_mb2: 'Le Temple NINNA-JI',
                    image_mb: './Images/Place/mb/2021_10_dande_ninnaji_1011_fin_web.png',
                    name: 'JAPON・KYOTO / Le Temple NINNA-JI',
                    time: '2021.11.2',
                    image: './Images/Place/2021_10_dande_ninnaji_1011_fin_web.jpg',
                    tips: 'Fermé au Publique',
                    url_msg: 'VOIR PLUS',
                    url: 'https://garden.naked.works/kyoto/'
                },
                {
                    name_mb1: 'JAPON・KYOTO',
                    name_mb2: 'Le Sanctuaire Kami-Gamo',
                    image_mb: './Images/Place/mb/2021_09_dande_kamigamo_fin_web.png',
                    name: 'JAPON・KYOTO / Le Sanctuaire Kami-Gamo',
                    time: '2021.10.27',
                    image: './Images/Place/2021_09_dande_kamigamo_fin_web.jpg',
                    tips: 'Fermé au Publique',
                    url_msg: 'VOIR PLUS',
                    url: 'https://garden.naked.works/kyoto/'


                },
                {
                    name_mb1: 'JAPON・TOKYO',
                    name_mb2: 'AKASAKA TBS',
                    image_mb: './Images/Place/mb/2021_10_dande_TVasa_0907-2_fin_web.png',
                    name: 'JAPON・TOKYO / AKASAKA TBS',
                    time: '2021.10.1 ー 2021.10.31',
                    image: './Images/Place/2021_10_dande_TVasa_0907-2_fin_web.jpg',
                    tips: 'Exposition Gratuite',
                    url_msg: '',
                    url: ''


                },
                {
                    name_mb1: 'JAPON・SAGA',
                    name_mb2: 'L\'observatoire de la Préfecture de SAGA',
                    image_mb: './Images/Place/mb/2021_10_damde_saga_fin_web.png',
                    name: 'JAPON・SAGA / L\'observatoire de la Préfecture de SAGA',
                    time: '2021.9.28 ー',
                    image: './Images/Place/2021_10_damde_saga_fin_web.jpg',
                    tips: 'Billet Requis',
                    url_msg: 'VOIR PLUS',
                    url: 'https://garden.naked.works/saga/'


                },
                {
                    name_mb1: 'JAPAN・SAITAMA',
                    name_mb2: 'MOOMINVALLEY PARK',
                    image_mb: './Images/Place/mb/2020_11_dande_moomin_fin_web.png',
                    name: "JAPAN・SAITAMA / MOOMINVALLEY PARK",
                    time: "2020.11.21 － 2021.03.07",
                    image: "./Images/Place/2020_11_dande_moomin_fin_web.jpg",
                    tips: '',
                    url_msg: '',
                    url: ''
                },
                {
                    name_mb1: 'JAPAN・TOKYO',
                    name_mb2: 'MIYASHITA PARK',
                    image_mb: './Images/Place/mb/2020_09_dande_miyashita_fin_web.png',
                    name: "JAPAN・TOKYO / MIYASHITA PARK",
                    time: "2020.11.09 ー 2020.11.15",
                    image: "./Images/Place/2020_09_dande_miyashita_fin_web.jpg",
                    tips: '',
                    url_msg: '',
                    url: ''
                },
                {
                    name_mb1: 'SINGAPORE',
                    name_mb2: 'GARDENS BY THE BAY',
                    image_mb: './Images/Place/mb/2020_09_dande_singapore_fin_web.png',
                    name: "SINGAPORE / GARDENS BY THE BAY",
                    time: "2020.11.09 ー 2020.11.15",
                    image: "./Images/Place/2020_09_dande_singapore_fin_web.jpg",
                    tips: '',
                    url_msg: '',
                    url: ''
                },
                {
                    name_mb1: 'JAPAN・TOKYO',
                    name_mb2: 'TOKYO TOWER',
                    image_mb: './Images/Place/mb/2021_09_dande_tokyotower_a4_fin_web.png',
                    name: "JAPAN・TOKYO / TOKYO TOWER",
                    time: "2020.11.09 ー",
                    image: "./Images/Place/2021_09_dande_tokyotower_a4_fin_web.jpg",
                    tips: '',
                    url_msg: '',
                    url: ''
                }
            ]
        }
    }
}